import { Auth } from 'aws-amplify';
import forceLogout from './forceLogout';

const checkValidityCookiesTokens = async () => {
    const session = await Auth.currentSession();
    console.log(`CURRENT_SESSION: ${JSON.stringify(session)}`)

    try {
        const cognitoUser = await Auth.currentAuthenticatedUser();
        // console.log(`Verify token: ${getCookie("refresh_token")}`)
        const currentSession = await Auth.currentSession();
        await new Promise((res, rej)=>{
            cognitoUser.refreshSession(currentSession.refreshToken, (err, session) => {
                console.log('session', err, session);
                if(err) rej()
                res(session)
              });
        })
      } catch (e) {
        console.log('Unable to refresh Token -> Force logout', e);
        await forceLogout();
      }
};

export default checkValidityCookiesTokens;
